export default "__VITE_ASSET__CNtxumXu__"